module.exports = __webpack_public_path__ + "static/media/selo3.d8424b8f.png";